import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { requiredFieldWithRegex, inputRegex } from '@/reusableInputConfig/reusableInputConfig';

const billingDayOptions: Record<number, string> = {
  1: '1st of the month',
  5: '5th of the month',
  15: '15th of the month',
  20: '20th of the month',
  28: '28th of the month',
};

export const billingDayEnding = (billingDay: keyof typeof billingDayOptions) => (
  billingDayOptions[billingDay]
);

export const formFields = {
  isAccountHolder: {
    label: 'I am the account holder',
    id: 'isAccountHolder',
    type: 'boolean',
  },
  accountHolderName: {
    label: 'Account holder name',
    id: 'accountHolderName',
    type: 'text',
  },
  accountNumber: {
    label: 'Account number',
    id: 'accountNumber',
    type: 'text',
  },
  sortCode: {
    label: 'Sort code',
    id: 'sortCode',
    type: 'text',
  },
  billingDay: {
    label: 'Select a billing day',
    id: 'billingDay',
    options: Object.entries(billingDayOptions).map(([value, displayValue]) => ({ value, displayValue })),
  },
};

export const getRules = () => ({
  [formFields.isAccountHolder.id]: yup.boolean(),
  [formFields.accountNumber.id]: yup.string()
    .required('Please fill in your account number')
    .matches(/^[0-9]+$/, 'This field only accepts numbers'),
  [formFields.billingDay.id]: yup.string().required('Please select a billing day'),
  [formFields.accountHolderName.id]: yup.string()
    .when('isAccountHolder', (isAccountHolder, schema) => {
      if (!isAccountHolder?.[0]) {
        return requiredFieldWithRegex(
          inputRegex.NAME.PATTERN,
          inputRegex.NAME.ERROR,
          'Please fill in the account holder\'s name'
        );
      }
      // When user is the account holder, no validation needed (field hidden)
      return schema;
    }),
  [formFields.sortCode.id]: yup.string()
    .required('Please fill in your sort code')
    .matches(/^[0-9-]+$/, 'This field only accepts numbers and hyphens'),

});

export const getFormSchema = () => (
  yup.object().shape(getRules())
);

export const getFormResolver = () => (
  yupResolver(getFormSchema())
);
